import { useContext } from 'react'
import { TitleContext } from './title.context'

export function useTitle() {
  return useContext(TitleContext)
}
